<telxl-shared-overlay-modal>
    <ng-template #modalBody>
        <div
            class="d-flex align-items-center justify-content-center flex-column"
        >
            <i class="fa-light fa-triangle-exclamation"></i>
            <p class="font-xs text-center mt-3 mb-3">
                Are you sure you want to merge with this customer?
            </p>
            <p class="font-lg text-center">
                &#x201C;{{ mergeWithName() }}&#x201D;
            </p>
            <p class="font-xs text-center mb-3 weight-light">
                Note: Previous file will be permanently deleted and replaced by
                this version
            </p>
            <div class="d-flex justify-content-center">
                <telxl-button
                    class="me-1"
                    colour="secondary"
                    [outline]="true"
                    (buttonClick)="close(false)"
                >
                    Cancel
                </telxl-button>
                <telxl-button
                    class="ms-1"
                    colour="primary"
                    [outline]="true"
                    (buttonClick)="close(true)"
                >
                    Merge
                </telxl-button>
            </div>
        </div>
    </ng-template>
</telxl-shared-overlay-modal>
